import React, { useMemo } from 'react';
import { Autocomplete, TextField, Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const LEADERSHIP_POSITIONS = [
  { id: '002ad10712bb48b3b08334b26e57491a', name: 'S/P/D Treasurer' },
  { id: '5b1e6163236443068d07183eace13bbe', name: 'S/P/D Organizer' },
  { id: '9106b4e431cf409da0823b1e7835bd48', name: 'S/P/D President' },
  { id: 'a0d6b40f5a0f4214ac928f2f0b3e77b9', name: 'S/P/D Secretary' },
  { id: 'f3a01279645945748754897d2e572a7e', name: 'S/P/D Vice President' },
  {
    id: '0063de12834544deaebed87d985638ff',
    name: 'Local Chapter Membership Chair',
  },
  {
    id: '070e1690d8de4854bb22a3b35bd3742b',
    name: 'Local Chapter Recording Secretary',
  },
  {
    id: '4f55953df0b04bc9b76a775c420a8460',
    name: 'Local Chapter Technology Contact',
  },
  { id: '888c4b116aae46e496c1f2c8ad9feb34', name: 'Local Chapter Chaplain' },
  { id: '8af77101465e4650a6af36bbc183f142', name: 'Local Chapter Guard' },
  {
    id: '98619508202847c8adc15a4b11a079f7',
    name: 'Local Chapter Vice President',
  },
  { id: 'c8094b8d6c514c219f4a5bbdd2c72b6b', name: 'Local Chapter President' },
  { id: 'cc32bed8f4784291b0424e830f0c8cc7', name: 'Local Chapter Treasurer' },
  {
    id: 'dc10f6cbd8e94070bb73b4685b5e84b8',
    name: 'Local Chapter Corresponding Secretary',
  },
  { id: '3a1be16c08124e2f9c0c9a586300f788', name: 'ELF Chair' },
  { id: '8b929bff2721444c89c40bff12a5a281', name: 'PSA Chair' },
  { id: 'a72ce9faa02144b6b4895d42b3033d0a', name: 'Cottey Chair' },
  { id: 'c0c110710f584e6ead6677c85945bd14', name: 'IPS Chair' },
  { id: 'c49c712623d64de381c6d9bf37f28f8a', name: 'PCE Chair' },
  { id: 'ff1db84ddec34608afa38d7895bafee9', name: 'STAR Chair' },
  { id: '2e658e79a9294c8cb1d59bc1fefda698', name: 'Reciprocity President' },
  { id: '3dd3928d981e4faa85eaeed8395410e2', name: 'Reciprocity Contact' },
  {
    id: '987cc3a6e7784fa4b595c0c85419b0e9',
    name: 'Reciprocity Vice President',
  },
  { id: 'cbf81e2f48ff4ea291516186edffc575', name: 'Reciprocity Treasurer' },
];

interface Position {
  id: string;
  name: string;
}

interface LeadershipPositionsFilterProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
}

const LeadershipPositionsFilter: React.FC<LeadershipPositionsFilterProps> = ({
  value,
  onChange,
  disabled = false,
  required = false,
}) => {
  const selected = useMemo(() => {
    if (!value) return [];
    const ids = value
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    return LEADERSHIP_POSITIONS.filter((p) => ids.includes(p.id));
  }, [value]);

  const handleChange = (_event: any, newValue: Position[]) => {
    onChange(newValue.map((p) => p.id).join(','));
  };

  return (
    <Autocomplete
      multiple
      id="leadership-positions-filter"
      options={LEADERSHIP_POSITIONS}
      disableCloseOnSelect
      disabled={disabled}
      value={selected}
      onChange={handleChange}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderOption={(props, option, { selected: sel }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={sel}
          />
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Individual positions"
          placeholder="Select positions..."
          required={required}
          size="small"
        />
      )}
    />
  );
};

export default LeadershipPositionsFilter;
